import { effects as orders } from './orders';
import { effects as drafts } from './drafts';
import { effects as draftDetails } from './draftDetails';
import { effects as orderDetails } from './orderDetails';
import { effects as authorizeOrder } from './authorizeOrder';
import { effects as captureOrder } from './captureOrder';
import { effects as refundOrder } from './refundOrder';
import { effects as cancelOrder } from './cancelOrder';
import { effects as payoutRules } from '../settings/payoutRules/payoutRules';
import { effects as newPayoutRule } from '../settings/payoutRules/newPayoutRule';

const effects = {
    ...orders,
    ...drafts,
    ...draftDetails,
    ...orderDetails,
    ...authorizeOrder,
    ...captureOrder,
    ...refundOrder,
    ...cancelOrder,
    ...payoutRules,
    ...newPayoutRule,
};

export default effects;
